import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SharedModule } from 'src/app/modules/shared.module';
import { FileManagerComponent } from './file-manager.component';
import { DetailDialogComponent } from './modals/detailDialog/detailDialog.component';
import { NewFolderDialogComponent } from './modals/newFolderDialog/newFolderDialog.component';
import { RenameDialogComponent } from './modals/renameDialog/renameDialog.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    MatToolbarModule,
    FlexLayoutModule,
    MatIconModule,
    MatGridListModule,
    MatMenuModule,
    MatDialogModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
  ],
  declarations: [FileManagerComponent, NewFolderDialogComponent, RenameDialogComponent, DetailDialogComponent],
  exports: [FileManagerComponent],
  entryComponents: [NewFolderDialogComponent, RenameDialogComponent, DetailDialogComponent]
})
export class FileManagerModule { }
